import { FC } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { CustomModal } from "../../../../components/CustomModal/CustomModal";
import { CustomTypography } from "../../../../components/CustomTypography/CustomTypography";
import { useDeleteDepartment } from "../../../../api/departments";
import { getCurrentFleetId } from "../../../../utils/getCurrentFleet";

type Props = {
  open: boolean;
  service: TDepartment | null;
  onClose: () => void;
  onCancel: () => void;
};

export const ModalDeleteService: FC<Props> = ({
  open,
  service,
  onClose,
  onCancel,
}) => {
  const { t } = useTranslation();
  const { mutate: deleteDepartment } = useDeleteDepartment(
    getCurrentFleetId(),
    onClose
  );

  const onConfirm = () => {
    if (!service?.id) return;
    deleteDepartment(service.id);
  };

  return (
    <CustomModal
      open={open}
      title={""}
      onClose={onClose}
      onCancel={onCancel}
      onSave={() => toast.success(t("common.changeSaved", "Change saved"))}
      isConfirmation
      textConfirmation={t("common.confirm", "Confirm")}
      onConfirm={onConfirm}
    >
      <div style={{ padding: "10px 0px", textAlign: "center" }}>
        <CustomTypography
          text={t("setting.deleteServiceWarning", {
            name: service?.name ?? "",
            defaultValue:
              "</br>You are about to delete the service <b>{{name}}</b>.</br>This action cannot be undone.</br></br>Do you confirm?",
          })}
          variant="default"
        />
      </div>
    </CustomModal>
  );
};
